import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { Link } from 'react-router';

import { ArrowLeft as ArrowLeftIcon } from '../../icons';
import { Typography } from '..';

export interface BackLinkProps {
  className?: string;
  label: string;
  linkPath: string;
  onClick?: () => void | undefined;
  testId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  backLink: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 0,
    textDecoration: 'none',

    '&:visited': {
      color: theme.palette.common.black,

      '& svg': {
        color: theme.palette.common.black,
      },

      '&:hover': {
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },

    '&:hover': {
      '& svg': {
        color: theme.palette.primary.main,
      },

      '& $linkText': {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },

  linkText: {
    display: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    backLink: {
      marginBottom: theme.spacing(3.5),

      '& .fd-icon': {
        height: 24,
      },
    },
  },

  [theme.breakpoints.up('md')]: {
    backLink: {
      marginBottom: theme.spacing(0.5),

      '& .fd-icon': {
        marginRight: theme.spacing(1.5),
      },
    },

    linkText: {
      border: '1px solid transparent',
      display: 'inline-block',
      textTransform: 'uppercase',

      '&:hover': {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
      },
      '&:visited': {
        color: theme.palette.common.black,
      },
      '&:active': {
        color: theme.palette.common.black,
      },
    },
  },
}));

export function BackLink(props: BackLinkProps): JSX.Element {
  const classes = useStyles();
  const {
    className = '',
    label,
    linkPath,
    onClick: onClickCallback,
    testId = '',
  } = props;

  const backLinkStyles = clsx(classes.backLink, 'fd-backlink', className || '');
  const dataFdProp = testId && { 'data-fd': testId };

  return (
    <Link
      aria-label={label}
      className={backLinkStyles}
      {...dataFdProp}
      onClick={onClickCallback}
      role="button"
      title={label}
      to={linkPath}
    >
      <ArrowLeftIcon size="s" />

      <Typography className={classes.linkText} variant="body2">
        {label}
      </Typography>
    </Link>
  );
}
